import { Component, Input, TemplateRef } from '@angular/core';
import { Placement } from '@fundamental-ngx/core/shared';

@Component({
    selector: 'app-helpful-label',
    templateUrl: './helpful-label.component.html',
    styleUrls: ['./helpful-label.component.scss'],
    standalone: false
})
export class HelpfulLabelComponent {
	@Input() for: string;
	@Input() required: boolean;
	@Input() label: string;
	@Input() popoverTitle: string;
	@Input() popoverBody: TemplateRef<any>;
	@Input() popoverPlacement: Placement = 'bottom';
	@Input() width = '25rem';
	@Input() tooltip: string;
	@Input() enabled = true;
}
